import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './app';
import reportWebVitals from './report-web-vitals';

import {Provider} from 'react-redux';
import store from './store/store-config';
import {useGlobalLoader} from './store/global-slice';
import {useAuthLoader} from './store/auth-slice';
import {ConfigProvider} from 'antd';
import locale from 'antd/lib/locale/zh_CN';

const ComponentInject = () => {
    useGlobalLoader();
    useAuthLoader();
    return null;
};

ReactDOM.render(
    <React.StrictMode>
        <ConfigProvider locale={locale}>
            <Provider store={store}>
                <App />
                <ComponentInject />
            </Provider>
        </ConfigProvider>
    </React.StrictMode>,
    document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
